// extracted by mini-css-extract-plugin
export default {"login_container":"Auth_login_container__WfvoK"};